import { Header } from "../../models/Header";

export const magasinheader: Header[] = [
    {
        
        field: "magasin.mag_nom",
        fieldLabel: "Magasin",
        fieldFormat: "",
        isDisplayed: true,
        align: "",
        isAddOnly: false,
        isMutable: false
    },
    {
        
        field: "nombre_vise",
        fieldLabel: "Vise",
        fieldFormat: "",
        isDisplayed: true,
        align: "",
        isAddOnly: false,
        isMutable: false
    },
    {
        
        field: "nombre_reel",
        fieldLabel: "Reel",
        fieldFormat: "",
        isDisplayed: true,
        align: "",
        isAddOnly: false,
        isMutable: false
    }
]